<template>
  <NavigationMenu class="w-full">
    <NavigationMenuList v-if="!route.params.project" class="max-w-screen-2xl mx-auto px-0 sm:px-6 lg:px-8">
      <div class="flex scale-[1] sm:scale-[1] origin-left pl-0 flex items-center  w-full">
        <div class="p-2 sm:block ml-0 pr-2 sm:pr-4">
        
          <NuxtLink class="cursor-pointer" to="/">
          
            <NuxtImg src="/general/logos/superseeded_logo_small.png" class="h-fill w-fill p-0 m-0 max-h-[2.5rem] max-w-[3rem] bg-transparent" />
          
          </NuxtLink>
          <!-- join waitlist button -->
        </div>
        <transition name="fade">
          <Button v-show="scrollY > 500" @click="handleJoin" size="sm" class="sm:hidden ml-2 text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 squircle-15 whitespace-nowrap">
            {{ canCreateTeam ? 'start now' : 'Join waitlist' }}
          </Button>
        </transition>
        
        <DropdownMenu v-if="route.path !== '/'" v-model:open="isDropdownOpen">
        <DropdownMenuTrigger>
          <Button variant="ghost" class="mx-0 px-4 sm:mx-1 hidden sm:flex items-center h-8 rounded-3xl dropdown-trigger hover:opacity-80" :class="`bg-${getCurrentMenuBgClass()} hover:bg-${getCurrentMenuBgClass()}`" >
            <!-- text-primary if 'go to'  -->
          <span class="text-[1em] sm:text-[1.1em] font-semibold uppercase text-white" :class="{'!text-primary': 
            getCurrentMenuTitle() == '' }" >
            {{ getCurrentMenuTitle() == '' ? '' : getCurrentMenuTitle() }}
          </span>
          <Icon v-if="getCurrentMenuTitle()!==''" name="lucide:chevron-down" class="w-4 h-4 ml-3 text-background transition-opacity duration-200 chevron-icon text-white"  />
          <Icon v-else-if="!isDropdownOpen" name="line-md:menu" class="w-6 h-6 text-background transition-opacity duration-200 chevron-icon text-primary"  />
          <Icon v-else name="line-md:menu-to-close-alt-transition" class="w-6 h-6 text-background transition-opacity duration-200 chevron-icon text-primary"  />
          
          
        </Button>  
        </DropdownMenuTrigger>
        <DropdownMenuContent class="!p-3 !shadow-none dropdown-content rounded-3xl bg-white dark:bg-primary" :class="getCurrentMenuBgClass()">
          <DropdownMenuItem 
            v-for="menu in getDropdownMenuItems()" 
            :key="menu.item.title"
            class="!m-0 !mb-2 last:!mb-0 !p-0 hover:!bg-transparent focus:!bg-transparent rounded-3xl"
          >
            <InteractiveHoverButton 
              @click="handleMenuItemClick(menu)" 
              :color="`${getMenuBgClass(menu)}`" 
              :text="menu.item.title" 
              class="text-[1em] sm:text-[1.1em] font-semibold uppercase w-full" 
            />
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

        <template v-else-if="route.path === '/'">
          <NavigationMenuItem v-for="menu in props.menuItems" :key="menu.item.title">
            <NavigationMenuTrigger 
              @click="menu.item.title === 'Workspace' && user ? navigateTo(`/team/${user.id}`) : navigateTo(menu.item.href)" 
              class="mx-0 px-2 sm:mx-1 sm:pl-3 no-chevron hidden sm:block !rounded-full hover:!bg-muted"
              :class="[
                isActiveMenuItem(menu) ? getMenuBgClass(menu) : 'bg-transparent !bg-transparent'
              ]"
            >
              <span 
                class="text-[1em] sm:text-[1.1em] font-semibold uppercase" 
                :class="[
                  isActiveMenuItem(menu) ? 'text-white' : menu.item.titleClass
                ]"
              >
                {{menu.item.title}}
              </span>
            </NavigationMenuTrigger>
            <NavigationMenuContent class="z[10000]">
              <div v-if="!menu?.image?.src">
                <ul class="grid w-[400px] max-w-[70vw] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
                  <li class="row-span-3">
                    <NavigationMenuLink as-child>
                      <a class="flex h-full w-full select-none flex-col justify-end rounded-md  no-underline outline-none focus:shadow-md"
                        href="/">
                        
                        <template v-if="menu.item.title === 'Wellspring'">
                          <ClientOnly>
                            <Vue3Lottie
                            animationLink="/wellspring_light.json"
                            class="!bg-transparent transform scale-[1.5] translate-y-[-50px]"
                            
                            />
                          </ClientOnly>
                        </template>
                        <template v-else-if="menu.item.title === 'Workspace'">
                          <ClientOnly>
                            <Vue3Lottie
                            animationLink="/dragdrop_light2.json"
                            class="!bg-transparent transform scale-[1.4] translate-y-[0px] min-h-[280px]"
                            
                            />
                          </ClientOnly>
                        </template>
                        <template v-else-if="menu.item.title === 'Chat'">
                          <ClientOnly>
                            <Vue3Lottie
                            animationLink="/chat_light.json"
                            class="!bg-transparent transform scale-[1.3] translate-y-[10px] min-h-[250px]"
                            
                            />
                          </ClientOnly>
                        </template>
                        
                        <NuxtImg v-else-if="menu?.item?.image?.src" :src="menu?.item?.image?.src" class="h-fill w-fill p-0 m-0 rounded-md" />
                        <!-- <div class="mb-2 mt-4 text-lg font-medium">

                        </div> -->
                        <p class="text-sm leading-tight text-muted-foreground">
                          <!-- some description here -->
                        </p>
                      </a>
                    </NavigationMenuLink>
                  </li> 
                  <NavbarListItem v-for="subMenu in menu.subMenuItems" :key="subMenu.title" :title="subMenu.title"
                    :href="menu.item.title === 'Workspace' && user ? `/team/${user.id}` : subMenu.href" :icon="subMenu.icon">
                    <span class="text-xl">{{ subMenu.description }}</span>
                  </NavbarListItem>
                </ul>
              </div>
              <div v-else>
                <ul class="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px]">
                  <li class="row-span-3">
                    <NavigationMenuLink as-child v-if="menu.image.title || menu.image.description">
                      <a class="flex h-full w-full select-none flex-col justify-end rounded-md bg-gradient-to-b from-muted/50 to-muted p-6 no-underline outline-none focus:shadow-md"
                        href="/">
                        <img height="350" :src="menu.image.src" class="h-fill w-fill p-0 m-0" />
                        <div class="mb-2 mt-4 text-xl">
                          {{menu.image.title}}
                        </div>
                        <p class="text-sm leading-tight text-muted-foreground">
                          {{menu.image.description}}
                        </p>
                      </a>
                    </NavigationMenuLink>
                    <img v-else:src="menu.image.src" class="h-fill w-fill p-0 m-0" />
                  </li>
                  <NavbarListItem v-for="subMenu in menu.subMenuItems.filter(e => !e.image)" :key="subMenu.title"
                    :title="subMenu.title" :href="menu.item.title === 'Workspace' && user ? `/team/${user.id}` : subMenu.href" :icon="subMenu?.icon">
                    {{ subMenu.description }}
                  </NavbarListItem>
                </ul>
              </div>
              
            </NavigationMenuContent>
          </NavigationMenuItem>
        </template>

        <div class="hidden sm:block ml-1">
          <Button 
            @click="handleJoin" 
            size="sm" 
            class="text-xs font-medium bg-primary text-primary-foreground hover:bg-primary/90 squircle-15 whitespace-nowrap transition-opacity duration-300 px-3"
            :class="{ 'opacity-0 pointer-events-none': scrollY <= 500, 'opacity-100': scrollY > 500 }"
          >
            {{ canCreateTeam ? 'start now' : 'join now' }}
          </Button>
        </div>
        
      </div>
    </NavigationMenuList>
    <div v-else class="max-w-screen-2xl mx-auto pl-4 -mr-6 sm:px-6 sm:-mr-6 lg:px-8 mt-0 pt-0">
      <MyBreadcrumbs />
    </div>
  </NavigationMenu>

</template>

<script setup>
import { navigationMenuTriggerStyle } from '@/components/ui/navigation-menu'
import {
    NavigationMenu,
    NavigationMenuContent,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger,
} from '@/components/ui/navigation-menu'
import { Button } from '@/components/ui/button'
import { InteractiveHoverButton } from '@/components/ui/interactive-hover-button'
import { GetNotified } from '#components'

useSquircleObserver()

const user = useSupabaseUser()
const { canCreateTeam } = useAccessControl()
const uiStore = useUiStore()
const { toggleBottomSheet, setBottomSheetDynamicComponent, setBottomDrawerConfig } = uiStore
const userStore = useUserStore()
const colorMode = useColorMode() 


const handleJoin = async () => {
  // If user is not logged in, redirect to login
  if (!user.value) {
    return navigateTo('/login')
  }

  // If user has access, go to dashboard
  if (canCreateTeam.value) {
    return navigateTo('/dashboard')
  }

  // Otherwise show waitlist bottom drawer
  setBottomDrawerConfig({
    title: '',
    component: markRaw(GetNotified),
    props: {
      email: user.value.email || ''
    }
  })
}


const route = useRoute();

const props = defineProps({
  scrollY: {
    type: Number,
    default: 0
  },
  menuItems: {
    type: Array,
  }
})

// Flag to check if we're on a team route
const isTeamRoute = computed(() => {
  return route.path.includes('/team/')
})

// Check if current route matches a menu item
const isActiveMenuItem = (menu) => {
  if (!menu?.item?.href) return false
  return route.path.includes(menu.item.href.split('/')[1])
}

// Get background class based on menu item
const getMenuBgClass = (menu) => {
  return `${menu.item.titleClass.replace('text-', '').replace('bg-', '')}`
}

// Get the opposite menu title
const getOppositeMenuTitle = (currentMenu) => {
  if (currentMenu?.item?.title === 'Wellspring') return 'Workspace'
  if (currentMenu?.item?.title === 'Workspace') return 'Wellspring'
  return currentMenu?.item?.title
}

// Get the opposite menu background class
const getOppositeMenuBgClass = (currentMenu) => {
  if (currentMenu?.item?.title === 'Wellspring') {
    // Find the Workspace menu item and use its class
    const workspaceMenu = props.menuItems.find(menu => menu.item?.title === 'Workspace')
    return getMenuBgClass(workspaceMenu)
  }
  if (currentMenu?.item?.title === 'Workspace') {
    // Find the Wellspring menu item and use its class
    const wellspringMenu = props.menuItems.find(menu => menu.item?.title === 'Wellspring')
    return getMenuBgClass(wellspringMenu)
  }
  return getMenuBgClass(currentMenu)
}

// Navigate to the opposite menu
const navigateToOppositeMenu = (currentMenu) => {
  if (currentMenu?.item?.title === 'Wellspring' && user.value) {
    navigateTo(`/team/${user.value.id}`)
  } else if (currentMenu?.item?.title === 'Workspace') {
    navigateTo('/wellspring')
  }
}

// If on a specific page, only show that menu item and the home link
const visibleMenuItems = computed(() => {
  // Filter out inactive items first
  const activeMenuItems = props.menuItems.filter(menu => menu.active !== false)
  
  // Always show all active menu items on homepage
  if (route.path === '/') return activeMenuItems
  
  // Special case for team routes - show Wellspring and Chat menu
  if (isTeamRoute.value) {
    return activeMenuItems.filter(menu => 
      menu.item?.title === 'Wellspring' || menu.item?.title === 'Chat'
    )
  }
  
  // if wellspring in the path - show Workspace and Chat
  if (route.path.includes('wellspring')) {
    return activeMenuItems.filter(menu => 
      menu.item?.title === 'Workspace' || menu.item?.title === 'Chat'
    )
  }

  // if chat in the path - show Workspace and Wellspring
  if (route.path.includes('/chat')) {
    return activeMenuItems.filter(menu => 
      menu.item?.title === 'Workspace' || menu.item?.title === 'Wellspring'
    )
  }

  // if supplier in the path - show other navigation options
  if (route.path.includes('/supplier')) {
    return activeMenuItems.filter(menu => 
      menu.item?.title === 'Wellspring' || menu.item?.title === 'Workspace' || menu.item?.title === 'Chat'
    )
  }

  
  return activeMenuItems
})

// Track dropdown state
const isDropdownOpen = ref(false)
const isHoveringTrigger = ref(false)

// Navigate to the appropriate page based on menu item
const handleMenuItemClick = (menuItem) => {
  if (!menuItem?.item) return
  
  // If it's a Workspace menu item and user is logged in, go to team page
  if (menuItem.item.title === 'Workspace' && user.value) {
    return navigateTo(`/team/${user.value.id}`)
  }
  
  // If it's a Wellspring menu item, go to wellspring
  if (menuItem.item.title === 'Wellspring') {
    return navigateTo('/wellspring')
  }
  
  // If it's a Suppliers menu item, go to suppliers
  if (menuItem.item.title === 'Suppliers') {
    return navigateTo('/supplier')
  }
  
  // Otherwise use the href from the menu item or fallback to home
  return navigateTo(menuItem.item.href || '/')
}

// Get dropdown menu items
const getDropdownMenuItems = () => {
  // Filter out inactive items first
  const activeMenuItems = props.menuItems.filter(menu => menu.active !== false)
  
  // If we're on team routes, show available navigation options  
  if (isTeamRoute.value) {
    return activeMenuItems.filter(menu => 
      menu.item?.title === 'Wellspring' || menu.item?.title === 'Chat' || menu.item?.title === 'Suppliers'
    )
  }
  
  // If we're on wellspring, show workspace and chat options
  if (route.path.includes('wellspring')) {
    return activeMenuItems.filter(menu => 
      menu.item?.title === 'Workspace' || menu.item?.title === 'Chat' || menu.item?.title === 'Suppliers'
    )
  }

  // If we're on chat, show workspace and wellspring options  
  if (route.path.includes('/chat')) {
    return activeMenuItems.filter(menu => 
      menu.item?.title === 'Workspace' || menu.item?.title === 'Wellspring' || menu.item?.title === 'Suppliers'
    )
  }

  // If we're on supplier routes, show other navigation options
  if (route.path.includes('/supplier')) {
    return activeMenuItems.filter(menu => 
      menu.item?.title === 'Wellspring' || menu.item?.title === 'Workspace' || menu.item?.title === 'Chat'
    )
  }

  // Default fallback
  return activeMenuItems.filter(menu => 
    menu.item?.title !== getCurrentPageMenu()?.item?.title
  )
}

// Get current page menu for context
const getCurrentPageMenu = () => {
  return props.menuItems.filter(menu => menu.active !== false).find(menu => isActiveMenuItem(menu))
}

// Get the current menu title
const getCurrentMenuTitle = () => {
  // Check if we're on team routes (workspace)
  if (isTeamRoute.value) {
    return 'Workspace'
  }
  
  // Check if we're on wellspring routes
  if (route.path.includes('wellspring')) {
    return 'Wellspring'
  }
  
  // Check if we're on chat routes
  if (route.path.includes('/chat')) {
    return 'Chat'
  }
  
  // Check if we're on supplier routes
  if (route.path.includes('/supplier')) {
    return 'Suppliers'
  }
  
  // Fallback: try to find active menu item
  const currentMenu = getCurrentPageMenu()
  return currentMenu ? currentMenu.item.title : ''
}

// Get the current menu background class
const getCurrentMenuBgClass = () => {
  // Filter out inactive items first
  const activeMenuItems = props.menuItems.filter(menu => menu.active !== false)
  
  // Check if we're on team routes (workspace)
  if (isTeamRoute.value) {
    const workspaceMenu = activeMenuItems.find(menu => menu.item?.title === 'Workspace')
    return workspaceMenu ? getMenuBgClass(workspaceMenu) : 'blue-800'
  }
  
  // Check if we're on wellspring routes  
  if (route.path.includes('wellspring')) {
    const wellspringMenu = activeMenuItems.find(menu => menu.item?.title === 'Wellspring')
    return wellspringMenu ? getMenuBgClass(wellspringMenu) : 'emerald-400'
  }
  
  // Check if we're on chat routes
  if (route.path.includes('/chat')) {
    const chatMenu = activeMenuItems.find(menu => menu.item?.title === 'Chat')
    return chatMenu ? getMenuBgClass(chatMenu) : 'purple-500'
  }
  
  // Check if we're on supplier routes
  if (route.path.includes('/supplier')) {
    const supplierMenu = activeMenuItems.find(menu => menu.item?.title === 'Suppliers')
    return supplierMenu ? getMenuBgClass(supplierMenu) : 'pink-400'
  }
  
  // Fallback: try to find active menu item
  const currentMenu = getCurrentPageMenu()
  return currentMenu ? getMenuBgClass(currentMenu) : 'bg-transparent'
}

</script>


<style>
.no-chevron svg {
  display: none;
}

@media (max-width: 640px) { /* Tailwind's breakpoint for 'sm' */
  button svg.lucide-chevron-down-icon {
    display: none !important;
  }
}

.dropdown-trigger:hover .chevron-icon {
  opacity: 1;
}

.dropdown-trigger:hover {
  cursor: pointer;
}

.dropdown-content {
  width: var(--radix-dropdown-menu-trigger-width);
  min-width: max-content;
  transform: translateX(0) !important;
  margin-left: 0 !important;
  margin-top: 4px !important;
}

div[id^="radix-vue-dropdown-menu-content"] {
  box-shadow: 0px 5.8px 1.4px -13px rgba(0, 0, 0, 0.058),
  0px 10.2px 3.3px -13px rgba(0, 0, 0, 0.078),
  0px 13.7px 6.3px -13px rgba(0, 0, 0, 0.09),
  0px 17.1px 11.2px -13px rgba(0, 0, 0, 0.1),
  0px 22.2px 20.9px -13px rgba(0, 0, 0, 0.113),
  0px 39px 50px -13px rgba(0, 0, 0, 0.15) !important;
  border: none !important;
  /* border-radius: 8rem !important; */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
.fade-enter-to, .fade-leave-from {
  opacity: 1;
}

.bg-grower {
  background-color: var(--grower);
}

.bg-designer {
  background-color: var(--designer);
}

.bg-contractor {
  background-color: var(--contractor);
}
</style>